<div *ngIf="show !== undefined ? show : showLoading" id="loading-spinner" class="loading-{{loadingId}}" >
    <div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    <h6 *ngIf="label" class="loading-data-label">{{ label }}</h6>
</div>
